import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../Components/Form/FormTextField';

const CustomerEditDialogPage = function CustomerEditDialogPage({
  errors,
  data,
  formData,
}) {
  const intl = useIntl();
  const { reset } = useFormContext();

  useEffect(() => {
    if (typeof data !== 'boolean' && Object.keys(data || {}).length > 0) {
      reset({
        ...(data ?? {}),
        ...(formData ?? {}),
      });
    }
  }, [data]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 6 }}>
        <FormTextField
          allUpperCase
          name="customerCode"
          error={errors?.customerCode}
          disabled
        />
      </Grid>
      <Grid size={{ md: 6 }}>
        <FormTextField
          allUpperCase
          name="companyName"
          label={intl.messages.COMPANY_NAME}
          error={errors?.companyName}
        />
      </Grid>
      <Grid size={{ md: 6 }}>
        <FormTextField
          name="fiscalCode"
          error={errors?.fiscalCode}
          allUpperCase
          maxCharacters={16}
          validateCallback={(cf) => {
            if (!cf) return true;
            return cf.length === 16 ? true : intl.messages.CF_ERROR;
          }}
        />
      </Grid>
      <Grid size={{ md: 6 }}>
        <FormTextField
          name="vatCode"
          error={errors?.vatCode}
          allUpperCase
          maxCharacters={11}
          validateCallback={(value) => {
            if (!value) return true;
            return /^[0-9]{11}$/.test(value) || intl.messages.INVALID_VATCODE;
          }}
        />
      </Grid>
    </Grid>
  );
};

CustomerEditDialogPage.propTypes = {
  errors: PropTypes.object,
  data: PropTypes.object,
  // formData: PropTypes.object,
};

export default CustomerEditDialogPage;
